import React from "react";

export const GroupsContext = React.createContext();

export default GroupsContext;
